import CreateCustomSelect from "./custom-select";

// const eldersHidden = document.querySelector("#elders-hidden");
// const childrenHidden = document.querySelector("#children-hidden");
// const eldersMinusButton = document.querySelector(".elders-choose .minus");
// const eldersPlusButton = document.querySelector(".elders-choose .plus");
// const eldersNumber = document.querySelector(".elders-choose .number");
// const childrenMinusButton = document.querySelector(".children-choose .minus");
// const childrenPlusButton = document.querySelector(".children-choose .plus");
// const childrenNumber = document.querySelector(".children-choose .number");

export default class PopupForm {
	constructor(button) {
		this.popup_button = button;
		this.popup_form_modal = document.querySelector("#popup_form_modal");
		this.close_btn = this.popup_form_modal.querySelector("#close_btn");
		this.wpcf7elem = this.popup_form_modal.querySelector(".wpcf7");
		this.modalContent = this.popup_form_modal.querySelector(".modal-content")
		this.body = document.querySelector("body");
		this.eldersHidden = this.popup_form_modal.querySelector("#elders-hidden");
		this.childrenHidden =
			this.popup_form_modal.querySelector("#children-hidden");
		this.eldersMinusButton = this.popup_form_modal.querySelector(
			".elders-choose .minus"
		);
		this.eldersPlusButton = this.popup_form_modal.querySelector(
			".elders-choose .plus"
		);
		this.eldersNumber = this.popup_form_modal.querySelector(
			".elders-choose .number"
		);
		this.childrenMinusButton = this.popup_form_modal.querySelector(
			".children-choose .minus"
		);
		this.childrenPlusButton = this.popup_form_modal.querySelector(
			".children-choose .plus"
		);
		this.childrenNumber = this.popup_form_modal.querySelector(
			".children-choose .number"
		);
	}
	init() {
		if (!this.popup_button || !this.popup_form_modal) return;
		this.popup_button.addEventListener("click", (e) => {
			e.preventDefault();
			this.popup_form_modal.classList.add("show");
			this.body.classList.add("overflow");
		});
		this.close_btn &&
			this.close_btn.addEventListener("click", () => {
				this.popup_form_modal.classList.remove("show");
				this.body.classList.remove("overflow");
			});

		this.buttonControls();
		this.formSetup();
		this.wpcf7elem.addEventListener(
			"wpcf7mailsent",
			(event) => {
				this.displayThankYou();
			},
			false
		);
	}

	formSetup() {
		const custom_selects =
			this.popup_form_modal.querySelectorAll(".custom-select");
		custom_selects &&
			custom_selects.forEach((el) => {
				new CreateCustomSelect(el);
			});

		const datepickers = this.popup_form_modal.querySelectorAll(".datepicker");
		datepickers.forEach((el) => {
			$(el).datepicker();
		});
	}

	buttonControls() {
		if (
			this.eldersHidden &&
			this.eldersNumber &&
			this.eldersMinusButton &&
			this.eldersPlusButton
		) {
			this.eldersPlusButton.addEventListener("click", (e) => {
				let i = this.eldersNumber.innerHTML;
				this.eldersNumber.textContent = ++i;
				this.eldersHidden.value = parseInt(this.eldersHidden.value) + 1;
			});

			this.eldersMinusButton.addEventListener("click", (e) => {
				let i = this.eldersNumber.innerHTML;
				if (i > 1) {
					this.eldersHidden.value = parseInt(this.eldersHidden.value) - 1;
					this.eldersNumber.textContent = --i;
				}
			});
		}

		if (
			this.childrenHidden &&
			this.childrenNumber &&
			this.childrenMinusButton &&
			this.childrenMinusButton
		) {
			this.childrenPlusButton.addEventListener("click", (e) => {
				let i = this.childrenNumber.innerHTML;
				this.childrenNumber.textContent = ++i;
				this.childrenHidden.value = parseInt(this.childrenHidden.value) + 1;
			});

			this.childrenMinusButton.addEventListener("click", (e) => {
				let i = this.childrenNumber.innerHTML;
				if (i > 0) {
					this.childrenHidden.value = parseInt(this.childrenHidden.value) - 1;
					this.childrenNumber.textContent = --i;
				}
			});
		}
	}
	displayThankYou() {
		if(!this.modalContent) return;
		this.wpcf7elem.remove();

		$(this.modalContent).append('<span class="thank-you-message">Hvala Vam</span>');


	}
}
